import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { ITEM_LIST_TEXTS } from "../shared/constants";

interface Props {
  open: boolean;
  itemName: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteItemDialog: React.FC<Props> = ({ open, itemName, isDeleting, onConfirm, onCancel }) => {
  return (
    <Dialog open={open} onClose={onCancel} data-testid="delete-dialog">
      <DialogTitle>{ITEM_LIST_TEXTS.deleteConfirmTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{ITEM_LIST_TEXTS.deleteConfirmMessage(itemName)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isDeleting}>
          {ITEM_LIST_TEXTS.cancelButton}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
          {ITEM_LIST_TEXTS.deleteButton}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteItemDialog;
